import React from "react";
import { Box, Grid, Card, CardContent, Typography } from "@mui/material";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import EngineeringIcon from "@mui/icons-material/PrecisionManufacturing";
import WavesIcon from "@mui/icons-material/Waves";
import MapIcon from "@mui/icons-material/Map";
import GroupsIcon from "@mui/icons-material/Groups";
import AssessmentIcon from "@mui/icons-material/Assessment"; // NEW ICON

const services = [
  {
    title: "Water & Wastewater",
    desc: "STPs, ETPs, WWTPs (MBBR, SBR, MBR) and sustainable purification systems.",
    icon: <WaterDropIcon sx={{ fontSize: 40, color: "#0288d1" }} />,
  },
  {
    title: "Sustainable Agriculture",
    desc: "Smart irrigation systems, soil moisture sensors & soil health monitoring.",
    icon: <AgricultureIcon sx={{ fontSize: 40, color: "#2e7d32" }} />,
  },
  {
    title: "DPRs & Engineering",
    desc: "Detailed feasibility studies, water supply planning & drainage designs.",
    icon: <EngineeringIcon sx={{ fontSize: 40, color: "#7b1fa2" }} />,
  },
  {
    title: "Groundwater Services",
    desc: "Advanced geophysical investigations & scientific borewell assessment.",
    icon: <WavesIcon sx={{ fontSize: 40, color: "#0277bd" }} />,
  },
  {
    title: "Spatial Mapping",
    desc: "Watershed management, GIS mapping & pipeline route analysis.",
    icon: <MapIcon sx={{ fontSize: 40, color: "#ef6c00" }} />,
  },
  {
    title: "Social Audits & CSR",
    desc: "Social Impact Assessments (SIA) & strategic CSR advisory services.",
    icon: <GroupsIcon sx={{ fontSize: 40, color: "#c62828" }} />,
  },

  {
    title: "Specialty Studies / Assessment",
    desc: "Source Vulnerability Assessment (SVA), Environmental & Social Due Diligence (ESDD).",
    icon: <AssessmentIcon sx={{ fontSize: 40, color: "#6a1b9a" }} />,
  },
];

const Services = () => {
  return (
    <Box
      id="services"
      sx={{
        p: { xs: 4, md: 10 },
        background: "linear-gradient(180deg, #FFFFFF 0%, #e1f5fe 100%)",
        scrollMarginTop: "80px",
      }}
    >
      <Typography
        variant="overline"
        align="center"
        display="block"
        sx={{ fontWeight: "bold", color: "#2e7d32", letterSpacing: 2, mb: 1 }}
      >
        WHAT WE DO
      </Typography>

      <Typography
        variant="h3"
        align="center"
        sx={{ mb: 6, fontWeight: "800", color: "#0d47a1" }}
      >
        Our Services
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                p: 2,
                borderRadius: 4,
                border: "1px solid rgba(0,0,0,0.05)",
                background: "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 12px 30px rgba(2, 136, 209, 0.15)",
                  borderColor: "#0288d1",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    textAlign: "center",
                    mb: 2,
                    p: 2,
                    bgcolor: "#f5f7fa",
                    borderRadius: "50%",
                    width: 80,
                    height: 80,
                    mx: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {service.icon}
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    textAlign: "center",
                    mb: 1.5,
                    color: "#1a237e",
                  }}
                >
                  {service.title}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    textAlign: "center",
                    lineHeight: 1.7,
                  }}
                >
                  {service.desc}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Services;
